import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Fade, Slide } from "react-awesome-reveal";
import Slider from "react-slick";
import "./style.css";
import { API_BASE_URL } from "@utils/constant";
import BlurryLoadingImage from "@components/lazyimage";

const settings = {
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: false,
  slidesToShow: 4.2,
  slidesToScroll: 1,
  initialSlide: 1,
  swipeToSlide: true,
  speed: 500,
  // variableWidth: true,
  draggable: true,
  rtl: false,
  dots: false,
  responsive: [
    {
      breakpoint: 1150,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 860,
      settings: {
        slidesToShow: 2.8,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 460,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const SuccesStory: React.FC<any> = ({ customClass, category = [] }) => {
  const [result, setResult] = useState<any[]>([]);

  async function fetchData(categories: number[]) {
    try {
      const allData = await Promise.all(
        categories.map(async (cat) => {
          const uri = `${API_BASE_URL}successstory/${cat}/1`;
          const response = await fetch(uri);
          if (!response.ok) return [];
          const data = await response.json();
          return data?.data || [];
        })
      );

      // Flatten and merge all category results
      const merged = allData.flat();
      setResult(merged);
    } catch (err) {
      console.error("Fetch Error :-S", err);
    }
  }

  useEffect(() => {
    if (Array.isArray(category) && category.length) {
      fetchData(category);
    }
  }, [category]);

  return (
    <div
      className={
        customClass ? "success-story1 " + customClass : "success-story1"
      }
    >
      <div className="col-12 items">
        <Slider {...settings}>
          {result.map((row: any) => (
            <div className="item" key={row.slug}>
              <Fade cascade damping={0.3}>
                <Link target="_blank" to={`/success-story/${row.slug}`}>
                  <BlurryLoadingImage
                    preview={row.featured_image}
                    image={row.featured_image}
                    alt={row.title}
                  />
                  <p dangerouslySetInnerHTML={{ __html: row.title }}></p>
                </Link>
                <Link target="_blank" to={`/success-story/${row.slug}`}>
                  Read More
                </Link>
              </Fade>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default SuccesStory;
